import { render, staticRenderFns } from "./NavigationMenuHeader.vue?vue&type=template&id=2aeeb7d2&scoped=true"
import script from "./NavigationMenuHeader.vue?vue&type=script&lang=js"
export * from "./NavigationMenuHeader.vue?vue&type=script&lang=js"
import style0 from "./NavigationMenuHeader.vue?vue&type=style&index=0&id=2aeeb7d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aeeb7d2",
  null
  
)

export default component.exports